import { removeEmptyValues } from "../../../utils/removeEmptyValues";
import { base64EncodeUnicode } from "../../../utils/base64";

interface CreateEventPayloadParams {
  event: {
    merchantId: string;
    campaignId: string;
    screenId: string;
    screenName: string;
    type: string;
    widgetConfigId: string;
    [index: string]: any;
  };
}

export function createEventPayload(
  this: any,
  { event }: CreateEventPayloadParams
): string {
  return base64EncodeUnicode(JSON.stringify(removeEmptyValues(event)));
}
